"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _clone = require("@utiljs/clone");

var _zhCN = _interopRequireDefault(require("./lang/zh-CN"));

/**
 * eg:
 * lng('Modal.confirm')
 * lng('DatePicker.Month.jan')
*/
var _lang = _zhCN.default;

var use = function use(lang) {
  _lang = lang;
};

var lng = function lng(path) {
  var value = (0, _clone.cloneJSON)(_lang);
  var arr = path.split('.');
  arr.forEach(function (i) {
    // @ts-ignore
    value = value[i];
  });
  return value || '';
};

var _default = {
  use: use,
  lng: lng
};
exports.default = _default;